import { render, staticRenderFns } from "./article12.vue?vue&type=template&id=52e5e101&scoped=true"
import script from "./article12.vue?vue&type=script&lang=js"
export * from "./article12.vue?vue&type=script&lang=js"
import style0 from "./article12.vue?vue&type=style&index=0&id=52e5e101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5e101",
  null
  
)

export default component.exports